.sidebar {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  width: 10rem;
  border: 1px solid var(--foreground);
  padding: 0.5rem;
}